import React from 'react';
import {CardTitle} from 'material-ui/Card';
import LinearProgress from 'material-ui/LinearProgress';
import Bookmark from 'material-ui/svg-icons/action/bookmark';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import AddNoteIcon from 'material-ui/svg-icons/action/note-add';
import {FormattedMessage, useIntl} from "react-intl";

const buttonContainerStyle = {
  position: 'absolute',
  right: 12,
  top: 100
}

const buttonStyle = {
  float: 'right',
  marginLeft: 10
}



const QuestionPageHeader = (props) => {
  var intl = useIntl();

  //TODO: MOve to shared function and use coding names for section (eg monitioring)
  const sectionTranslationTitles = {
    "Data Collection": intl.formatMessage({ id:"general.monitoring", defaultMessage:"Data Collection" }),
    "Assessment": intl.formatMessage({ id:"general.assessment", defaultMessage:"Assessment" }),
    "Management Measures": intl.formatMessage({id:"general.controlRules", defaultMessage:"Management Measures" }),
    "Enforcement": intl.formatMessage({ id:"general.enforcement", defaultMessage:"Enforcement" })
  }

  let catTitle = props.category ? props.category.title : ""
  let catTr = (props.translation && props.category) ? props.translation.categories.find(c => c.engID === props.category.id) : null
  if(catTr){ catTitle = catTr.title }
  return(
    <div style={{position:"relative"}}>
      <CardTitle title={<div>{sectionTranslationTitles[props.section] + " > "}<b>{catTitle}</b></div>} subtitle={intl.formatMessage({id:"questionPage.questionsCompleted", defaultMessage:"Question #{qNum} ({numAnswers} of {numQuestions} questions completed) - {cavOrCrit}"},  {qNum:props.position, numAnswers:props.numAnswers, numQuestions: props.numQuestions, cavOrCrit: props.cavOrCritText})} />
      <div style={buttonContainerStyle}>
        <RaisedButton
          label={intl.formatMessage({id:"general.notesBtn", defaultMessage:"{hasNote, select, true {Notes Taken} other {Take a Note}}"}, {hasNote: props.hasNote})}
          labelPosition="before"
          primary={false}
          icon={<AddNoteIcon color={props.hasNote ? "#bd7a00" : "rgb(185, 185, 185)"} />}
          style={props.hasNote ? {...buttonStyle, border: "1px solid rgb(126, 94, 22)"} : buttonStyle}
          backgroundColor={props.hasNote ? "rgb(244, 241, 230)" : "white"}
          style={buttonStyle}
          onClick={props.onTakeNote}
        />
        <RaisedButton
          label={intl.formatMessage({id:"general.bookmarked", defaultMessage:"{bookmarked, select, true {Bookmarked} other {Add Bookmark}}"}, {bookmarked: props.flagged})}
          labelPosition="before"
          primary={false}
          icon={<Bookmark color={props.flagged ? "rgb(22, 126, 82)" : "rgb(185, 185, 185)"} />}
          style={props.flagged ? {...buttonStyle, border: "1px solid rgb(22, 126, 82)"} : buttonStyle}
          backgroundColor={props.flagged ? "rgb(230, 243, 237)" : "white"}
          onClick={props.onToggleFlagged}
        />
      </div>
      <LinearProgress mode="determinate" value={(props.numAnswers / props.numQuestions) * 100} />
    </div>
  )
}

QuestionPageHeader.propTypes = {
  category: PropTypes.object.isRequired,
  section: PropTypes.string.isRequired,
  numQuestions: PropTypes.number.isRequired,
  numAnswers: PropTypes.number.isRequired,
  cavOrCritText: PropTypes.string.isRequired,
  hasNote: PropTypes.bool.isRequired,
  flagged: PropTypes.bool.isRequired,
  isFinishing: PropTypes.bool.isRequired
}

export default QuestionPageHeader;
